import React from "react";
import StaticPage from "@/components/StaticPage";

export default function Privacy() {
  return (
    <StaticPage eyebrow="Privacy" title="Privacy Policy">
      <p className="text-xs text-[#5C6B62]">Last updated: February 2026</p>

      <p>
        Your data is yours. This Privacy Policy explains what Tally collects, how we use it, and what controls you have.
      </p>

      <div>
        <div className="label-eyebrow mb-2">What we collect</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>Your email address and (optional) name when you sign up.</li>
          <li>Meals you log — ingredients, portion sizes, carb estimates, optional notes.</li>
          <li>Photos you upload are sent to our AI provider (Google or OpenAI) for ingredient analysis. We do not retain the original photo on our servers.</li>
          <li>If you provide your doctor&apos;s name/email, we store it only so it can appear in the PDF report header.</li>
          <li>Standard technical data: timestamps, app version, and basic device info for debugging.</li>
        </ul>
      </div>

      <div>
        <div className="label-eyebrow mb-2">What we don&apos;t do</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>We don&apos;t sell your data.</li>
          <li>We don&apos;t share your meal log with advertisers or third parties.</li>
          <li>We don&apos;t use your data to train our own AI models.</li>
        </ul>
      </div>

      <div>
        <div className="label-eyebrow mb-2">AI provider sharing</div>
        <p>
          When you tap <em>Analyze</em>, the photo is sent to Google (Gemini) or OpenAI (GPT-4o) — depending on which model you chose. Both providers process the image to identify ingredients and return them to Tally. Their use of the data is governed by their own privacy policies.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">Payments</div>
        <p>
          Subscription payments are processed by Stripe. Tally never sees or stores your full card number — only a transaction ID and your subscription status.
        </p>
      </div>

      <div>
        <div className="label-eyebrow mb-2">Your controls</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>Edit any logged meal or delete it from your Scans list at any time.</li>
          <li>Delete your account from <strong>Profile → Delete Account</strong>. This permanently removes your meals, your photo-analysis history, your sessions, and your account record.</li>
        </ul>
      </div>

      <p>
        Questions? Email{" "}
        <a className="text-[#1A2421] underline underline-offset-4" href="mailto:tallycarbcounter@gmail.com">
          tallycarbcounter@gmail.com
        </a>
        .
      </p>
    </StaticPage>
  );
}
